import React from 'react';

function Boards() {
  return (
    <>
      <h2>Boards</h2>
    </>
  );
}

export default Boards;